import util from '@bmp-vue/core/api/util'

const controller = 'ContaCorrente';

export default Object.assign({}, util.GetCrud(controller, null), {
    BuscaContasDF: function (dto) {
        return util.Axios.GetParams(controller, dto);
    }
});